import TrackingService from 'app/services/tracking/tracking.service';
import AdminService from "external-services/diary-admin-service/admin.service";
import ManagerService from "external-services/manager-service/manager.service";
import VenueActions, {VenueActionNames} from "app/actions/venue.actions";
import store from "appRoot/Store";
import {rootDisplayActions} from "app/reducers/display/slice";
import {appRoutes} from "appRoot/RouteManager";
import {venueActions} from "app/reducers/venue/slice";
import { DiaryRootState } from 'appRoot/rootReducer';
import { scheduleActions } from 'app/reducers/schedule/slice';

import OAuth2Service from 'external-services/oauth-login/OAuth2.service';
import { Roles } from 'external-services/manager-service/types';
// requiring html templates so that hot reloading works
const template = require('./mainMenu.html');

const NS = 'MainMenu'; // jshint ignore:line

export default function MainMenu(
  $rootScope, $state, $log, $mdSidenav, $mdDialog, $localStorage, $filter,
  AuthService, appValues, pouchService
) { // as mainMenu
  "ngInject";

  return {
    restrict: 'E',
    replace: true,
    controllerAs: 'vm',
    template,
    controller
  };

  function controller() {

    const account = AdminService.getAccount();
    const nameParts = [];

    const vm = this;
    //-- define public properties
    vm.isIPad = navigator.userAgent.match(/iPad/i) != null;
    vm.enableNewVenueSelector = window.config.enableNewVenueSelector;
    vm.appVersion = appValues.VERSION_SHORT;
    vm.selectedPage = null;
    vm.isManager = ManagerService.isManager;

    vm.isAdminOrStaff = account.roles?.some(role => role.name === Roles.BookItAdmin || role.name === Roles.BookItStaff);
    vm.enableNewVenueSelector = window.config.enableNewVenueSelector && vm.isAdminOrStaff;

    vm.menuItems = [{
      icon: 'mdi-book-open',
      name: 'Bookings',
      path: 'bookings',
      enabled: true,
      managerOnly: false
    }, {
      icon: 'mdi-account-multiple',
      name: 'Customers',
      path: 'customers',
      enabled: true,
      managerOnly: false
    }, {
      icon: 'mdi-chart-bar',
      name: 'Reports',
      path: 'reports.overview',
      enabled: true,
      managerOnly: true
    }, {
      icon: 'mdi-gift',
      name: 'Gift Cards',
      path: 'giftcards.management',
      enabled: true,
      managerOnly: true
    }, {
      icon: 'mdi-settings',
      name: 'Settings',
      path: 'settings.schedule',
      enabled: true,
      managerOnly: true
    }];
    vm.userRole = account.roles[0].name;

    checkAdminLinkAllowed();
    updateHeight();

    if (account.firstName) {
      nameParts.push(account.firstName);
    }
    if (account.surname) {
      nameParts.push(account.surname);
    }

    vm.displayName = nameParts.join(' ');
    vm.venues = account.venues;
    vm.venue = AdminService.getVenue();
    vm.venueId = vm.venue.id;

    //-- define public methods
    vm.changeSection = changeSection;
    vm.venueChange = venueChange;
    vm.toggleFullScreen = toggleFullScreen;
    vm.logout = logout;
    vm.goToAdmin = goToAdmin;
    vm.toVenueSwitcher = toVenueSwitcher;

    //-- listen
    $rootScope.$on('$stateChangeSuccess', checkSelected);
    document.addEventListener('webkitfullscreenchange', function () {
      checkFullScreen();
    }, false);
    document.addEventListener('mozfullscreenchange', function () {
      checkFullScreen();
    }, false);
    document.addEventListener('fullscreenchange', function () {
      checkFullScreen();
    }, false);
    $rootScope.$on('manager-change', managerChange);

    //-- init
    checkSelected();

    function managerChange() {
      vm.isManager = ManagerService.isManager;
      checkAdminLinkAllowed();
      updateHeight();
    }

    function updateHeight() {
      vm.height = 246;
      if (vm.isManager) {
        vm.height += 52;
      }
      if (vm.adminLinkAllowed) {
        vm.height += 52;
      }
      if (vm.userRole === 'VenueStaff') {
        vm.height += 52;
      }
    }

    function checkAdminLinkAllowed() {
      vm.adminLinkAllowed = true;
      // if (!vm.isManager || vm.isManager && account.roles[0].name === "VenueManager" || vm.isManager && account.roles[0].name === "Support") {
      //   vm.adminLinkAllowed = false;
      // }
      const hasAdminAccess = ManagerService.hasAdminAccess(account.roles);
      if (!hasAdminAccess) {
        vm.adminLinkAllowed = false;
      }
    }

    function logout(evt) {
      TrackingService.trackPageView('logout.question');
      var confirm = $mdDialog.confirm()
        .parent(angular.element(document.body))
        .title('Are you sure you would like to logout?')
        .ariaLabel('Logout')
        .ok('Yes')
        .cancel('No')
        .targetEvent(evt);
      $mdDialog.show(confirm).then(function () {
        TrackingService.trackEvent('Logout');

        if (window.config.enableOAuth2 && OAuth2Service.getIsEnableOAuth()) {
          OAuth2Service.logout().finally(() => {
            OAuth2Service.removeStoredDataForOauth();
            AuthService.logout();
          });
        } else {
          AuthService.logout();
        }
      });
    }

    function venueChange() {
      if (Number(AdminService.getVenue().id) !== Number(vm.venueId)) {
        AdminService.restartPeriodicCouchNameCheck(); // restarts the timer
        AdminService.loadVenue(vm.venueId).then(function () {
          $state.go('setup');
          $localStorage.couchUsers = null;
          // $rootScope.$broadcast('venue-change');
          VenueActions.venueAction(VenueActionNames.VENUE_CHANGE);
          store.dispatch(scheduleActions.clearScheduleLookUp()); // changing venue means removing old schedule lookup
          TrackingService.trackEvent('Venue Change');
        }).catch(function (err) {
          vm.state = vm.ERROR;
          vm.errorMsg = 'Venue failed to load';
          $log.error('err', err);
        });
      }
    }

    function checkSelected() {
      if (vm.selectedPage) {
        vm.selectedPage.cls = '';
      }
      // select the current page
      for (var i = vm.menuItems.length - 1; i >= 0; i--) {
        var page = vm.menuItems[i];
        if ($state.current.name === page.path) {
          page.cls = 'selected';
          vm.selectedPage = page;
        }
      }
    }

    function changeSection(evt, menu) {
      if (menu.func) {
        menu.func(evt);
      } else {
        $state.go(menu.path);
      }
      $mdSidenav('mainMenu').close();
    }

    function checkFullScreen() {
      if (!document.fullscreenElement &&
        !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
        vm.isFullscreen = false;
      } else {
        vm.isFullscreen = true;
      }
    }

    function toggleFullScreen() {
      if (!document.fullscreenElement && // alternative standard method
        !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) { // current working methods
        vm.isFullscreen = true;
        TrackingService.trackEvent('Fullscreen');
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) {
          document.documentElement.msRequestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        vm.isFullscreen = false;
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      }
    }

    function goToAdmin() {
      AuthService.openAdminLogin(true);
    }

    function toVenueSwitcher() {
      store.dispatch(rootDisplayActions.setRouteStatus(appRoutes.login));
      store.dispatch(venueActions.setIsSwitchVenue(true));
      store.dispatch(rootDisplayActions.setShowNewVenueSelector(true));
      $mdSidenav('mainMenu').close();
    }

  }
}
